import QualityInfo from './QualityInfo.vue'

export default QualityInfo
